<template>
  <v-dialog width="620px" :value="dialogShow">
    <v-card>
      <v-card-text class="text-center">
        <v-icon
            size="92px"
            class="mt-8"
            :color="status === 'success' ? 'success darken-1' : 'error darken-1'"
        >
          {{status === 'success' ? 'mdi-check-circle' : 'mdi-alpha-x-box-outline' }}
        </v-icon>
        <h3 class="mt-4">{{msg}}</h3>
        <v-btn
            outlined
            class="mt-4 px-8"
            color="indigo"
            @click="confirmationCallback"
        >
          {{btnName}}
        </v-btn>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ConfirmationDialog",
  props: {
    dialogShow: Boolean,
    msg: String,
    status: String,
    btnName: String,
    confirmationCallback: Function
  }
}
</script>

<style scoped>

</style>